<template lang="pug">
    v-list-tile
        v-layout.main-tile(row)
            v-flex.box.mr-4.xs1
                |{{parseFloat(value.quantity)}}
                //CounterControl(:value="value.quantity" @input="handleCounter($event)" :allowSetQuantity="enableEditQuantity"  :infoValue="value.stock" :sideControls="false" :minValue="1" :maxValue="value.stock")
            v-divider(vertical)
            v-flex(:class="stripLayout.detailsTile")
                slot(v-if="enableDescriptionSlot" name="description")
                SalesCartItemDetails(v-else :item="item")
            
            
            
</template>

<script>
/**
 * Component that shows an item list tile, containing different info and
 * functions depending on the computed layout for it.
 */
import CounterControl from '../CounterControl/CounterControl'
import SalesCartItemDetails from './subcomponents/SalesCartItemDetails'
export default {
    name: 'item-strip',
    data: function() {
        return {
            item: {},
        }
    },
    props: {
        /**
         * @description
         * Name(key) of the item property to be controlled by the CounterComponent.
         * @type {string}
         */
        countedPropertyName: {
            type: String,
            default: 'quantity',
        },
        /**
         * @description
         * Enables an slot for inserting content.
         */
        enableContentSlot: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         * Toggles visibility of the actions area at the end of the strip.
         */
        enableActionsSlot: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         * Toggles visibility of the Description slot in the middle of the strip.
         */
        enableDescriptionSlot: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         * Recieves Item to be controlled and displayed by this component.
         */
        value: {
            type: Object,
            default: () => {},
        },
        /**
         * @description
         * Array of objects containing custom actions for the item, if needed.
         * Object format:
         * @example
         *  {
         *      name: 'delete', --> Action Name.
         *      icon: 'delete', --> Material Icon for the action button.
         *      iconColor: 'red darken-2', --> Color for the action button.
         *      handler: this.defaultHandlers.deleteItem, IMPORTANT - Stores function to be triggered on button click.
         *      tooltip: 'eliminar', --> Tooltip to show when hovering action button.
         *  },
         */
        actions: {
            type: Array,
            default: () => [],
        },
        /**
         * @description
         * Object containing info about vuex action to be dispatched when this component's binded item
         * is modified. It needs the state module, the state prop to modify and the action to dispatch.
         * 
         * @example
         *  {
         *      module: 'CartModule',
         *      state: 'items',
         *      action: 'setCartItems'
         *  }
         */
        vuexBindings: {
            type: Object,
            default: null,
        },
        /**
         * @description
         * allows to edit quantity
         */
        enableEditQuantity: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        /**
         * @description this function modifies the layout of the Item Strip, depending on the enabled slots passed by props. It sets the visibility and v-flex grid widths for each tile using class binding.
         * @returns {object} Containing enabled classes for each tile.
         */
        stripLayout: function() {
            if (!this.enableContentSlot && !this.enableActionsSlot) {
                return {
                    detailsTile: { xs10: true },
                    contentTile: { 'disabled-tile': true },
                    actionsTile: { 'disabled-tile': true },
                }
            } else if (!this.enableContentSlot && this.enableActionsSlot) {
                return {
                    detailsTile: { xs7: true },
                    contentTile: { 'disabled-tile': true },
                    actionsTile: { xs3: true },
                }
            } else if (this.enableContentSlot && !this.enableActionsSlot) {
                return {
                    detailsTile: { xs7: true },
                    contentTile: { xs3: true },
                    actionsTile: { 'disabled-tile': true },
                }
            } else if (this.enableContentSlot && this.enableActionsSlot) {
                return {
                    detailsTile: { xs6: true },
                    contentTile: { xs2: true },
                    actionsTile: { xs2: true },
                }
            }
        },
    },
    methods: {
        /**
         * @description
         * Handles the emited value by CounterControl to update the item quantity on cart.
         * If Store Bindings are allowed, it will trigger the designed action. Else, it will
         * fire the input event with the updated item as payload.
         * @param {number} count - new item quantity returned by CounterControl Component
         */
        handleCounter: function(count) {
            //asigns new quantity to item
            this.value.quantity = count
            //recalculates subtotal with it's discounts
            let subtotal = this.value.sale_price * this.value.quantity
            if (this.value.discount_type == 'percentual') {
                subtotal =
                    (subtotal * (100 - this.value.discount_ammount)) / 100
            } else if (this.value.discount_type == 'fixed') {
                subtotal = subtotal - this.value.discount_ammount
            }
            //asigns new subtotal to item
            this.value.subtotal = subtotal
            // IMPORTANT - Deep clones the item for triggering reactivity
            // for Details component to show the updated subtotal and discounts.
            this.item = JSON.parse(JSON.stringify(this.value))
            //Triggers Vuex Action if defined
            if (this.triggerVuexAction()) return
            //Emit value to parent if no vuex action is defined
            this.$emit('input', this.value)
        },
        /**
         * @description
         * Checks if Vuex Store, module and action are setted.
         * If so, fetch cart items from store, finds and updates this component's
         * controled item and dispatch the action for updating the list
         */
        triggerVuexAction() {
            if (
                this.vuexBindings &&
                this.vuexBindings.module &&
                this.vuexBindings.state &&
                this.vuexBindings.action
            ) {
                let items = this.$store.state[this.vuexBindings.module][
                    this.vuexBindings.state
                ]
                const index = items.findIndex(item => item.id == this.value.id)
                items[index] = this.value
                this.$store.dispatch(
                    this.vuexBindings.module + '/' + this.vuexBindings.action,
                    items
                )
                return true
            } else {
                return false()
            }
        },
    },
    components: {
        CounterControl,
        SalesCartItemDetails,
    },

    created() {
        this.item = this.value
    },
}
</script>


<style lang="scss" scoped>
.ejemplo {
    border: 1px solid black;
}
.disabled-tile {
    display: none;
}
.box{
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
